import { PlusOutlined } from '@ant-design/icons'
import { Button, Col } from 'antd'
import React, { useState } from 'react'

import FAQDetails from './FAQDetails';
import FaqList from './FaqList';

function FaqView() {

    const [record, setRecord] = useState(false);
    const [hasUpdated, setHasUpdated] = useState(true);
    const [modalType, setModalType] = useState("Add");
    const [visible, setVisible] = useState(false)

    const showModal = (record = {}, type = "add", open = true) => {

        setRecord(record);
        setModalType(type);
        setVisible(open);
    };

    return (
        <>
            <div className="content">
                <Col xs={24}>
                    <h1 className="center-align">Manage Frequently Asked Questions</h1>
                </Col>
                <Button
                    className="add-button"
                    key="add-button-1"
                    type="primary"
                    onClick={() => showModal({}, "add", true)}
                    icon={<PlusOutlined />}
                >
                    {""} Add New
                </Button>
                <FAQDetails
                    key={"a2"}
                    record={record}
                    showModal={showModal}
                    setHasUpdated={setHasUpdated}
                    type={modalType}
                    visible={visible}
                    setVisible={setVisible}
                />
                <FaqList
                    key={"faq-list"}
                    showModal={showModal}
                    hasUpdated={hasUpdated}
                    setHasUpdated={setHasUpdated}
                />
            </div>
        </>
    )
}

export default FaqView